import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { initializeApi } from 'api'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { RootState } from './types'
import posReducer from 'reducers/pos'
import customerReducer from 'reducers/customer'
import barcodeScannerReducer from 'reducers/barcodeScanner'

const api = initializeApi()

const appReducer = combineReducers({
  pos: posReducer,
  customer: customerReducer,
  barcodeScanner: barcodeScannerReducer,
  [api.reducerPath]: api.reducer,
})

export function buildStore(preloadedState = {}) {
  return configureStore({
    reducer: appReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(api.middleware),
    preloadedState,
  })
}

type Store = ReturnType<typeof buildStore>
export type AppDispatch = Store['dispatch']

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
